<template>
    <div class="card">
        <DataTable
            :value="data"
            v-model:selection="selectedTypes"
            v-model:filters="filterParams.filters"
            filterDisplay="row"
            paginator
            lazy
            :rows="filterParams.perPage"
            :rowsPerPageOptions="[50, 100, 200]"
            :total-records="total"
            :loading="loading"
            @page="onPage($event)"
            @filter="getData()"
            class="customTable"
            @row-select-all="onSelectAllChange"
            @row-select="onRowSelect"
            @row-unselect="onRowUnselect"
        >
        <template #header>
            <div class="table-header">
                <h5 class="p-m-0">
                    Типи аксесуарів
                </h5>
            </div>
        </template>
            <Column selectionMode="multiple" :class="{'select-all-selected': selectAll}" headerStyle="width: 3rem"></Column>
            <Column field="name" header="Найменування">
                <template #body="slotProps">
                    <InputText class="price_input" v-model="slotProps.data.name" />
                </template>
                <template #filter>
                    <InputText v-model="filterParams.filters.name.value" type="text" @input="getData()" placeholder="Пошук" />
                </template>
            </Column>
            <Column field="" header="">
                <template #body="slotProps">
                    <a href="#" @click.prevent="() => {selectedTypes=[]; selectedTypes.push(slotProps.data); deleteTypes()}">
                        <svg width="10" height="10" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M1.26671 9.66683L0.333374 8.7335L4.06671 5.00016L0.333374 1.26683L1.26671 0.333496L5.00004 4.06683L8.73337 0.333496L9.66671 1.26683L5.93337 5.00016L9.66671 8.7335L8.73337 9.66683L5.00004 5.9335L1.26671 9.66683Z" fill="#B70D09"/>
                        </svg>
                    </a>
                </template>
            </Column>
        </DataTable>

        <div class="bottom_btns">
            <a href="javascript:void(0)" class="add_file_btn" @click="save()">Зберегти</a>
            <a href="javascript:void(0)" class="add_file_btn main" @click="isAddTypes=true">Додати новий тип</a>
            <a href="javascript:void(0)" class="add_file_btn main" v-if="selectedTypes.length" @click="deleteTypes()">Видалити</a>
            <a href="javascript:void(0)" class="add_file_btn main disabled" v-else>Видалити</a>
        </div>

        <Dialog v-model:visible="isAddTypes" id="types-table" header="Створення нового типу" :style="{ width: '500px' }" modal :contentStyle="{ height: '150px' }">
            <div class="modal_main_content_container">
                <InputText class="price_input" placeholder="Назва" v-model="newType.name" />
            </div>
            <template #footer>
                <div class="confirm_buttons">
                    <a href="#" class="confirm_button_cancel" @click.prevent="addTypes()">Додати</a>
                    <a href="#" class="confirm_button_confirm" @click.prevent="isAddTypes=false">Відмінити</a>
                </div>
            </template>
        </Dialog>
    </div>
</template>

<script>
import axios from "axios";
import AppLayout from "@/Layouts/AppLayout";
import DataTable from "primevue/datatable";
import Column from 'primevue/column';
import InputText from 'primevue/inputtext';
import swal from 'sweetalert2';
import Dialog from 'primevue/dialog';
import Dropdown from 'primevue/dropdown';
import Toast from 'primevue/toast';
import {FilterMatchMode} from "primevue/api";

export default {

    components: {
        DataTable,
        Column,
        InputText,
        swal,
        Dialog,
        Dropdown,
        Toast,
    },
    layout: AppLayout,

    data() {
        return {
            data: [],
            total: 0,
            selectedTypes: [],
            filterParams: {
                page: 1,
                perPage: 50,
                filters: {
                    name: { value: null, matchMode: FilterMatchMode.CONTAINS },
                }
            },
            newType: {
                name: null,
            },
            loading: false,
            selectAll: false,
            isAddTypes: false,
            viewVariants: [
                {
                    value: null,
                    name: 'Всі'
                },
                {
                    value: true,
                    name: 'Активні'
                },
                {
                    value: false,
                    name: 'Приховані'
                },
            ]
        }
    },

    mounted() {
        this.getData();
    },

    methods: {
        save() {
            axios.post(this.route('api.vector.acessories.types.update'), {data: this.data}).then(result => {
                this.$toast.add({ severity: 'success', summary: 'Успішно збережено!', detail: 'Типи документів успішно оновлено', life: 3000 });
                this.getData()
            });
        },
        addTypes() {
            axios.post(this.route('api.vector.acessories.types.update'), this.newType).then(result => {
                this.newType = {
                    name: null,
                }

                this.isAddTypes = false
                
                this.getData()
            });
        },
        getData() {
            this.loading = true
            axios.post(this.route('api.vector.acessories.types.list'), this.filterParams).then(result => {
                this.data = result.data.types.data;
                this.total = result.data.types.total;
                this.loading = false
            });
        },
        deleteTypes() {
            new swal({
                title: 'Ви впевнені?',
                text: 'Обрані типи аксесуарів будуть видалені',
                icon: 'warning',
                showConfirmButton: true,
                showCancelButton: true,
                buttons: ['Скасувати', 'Підтвердити'],
            }).then((result) => {
                if (!result.isConfirmed) {
                    this.selectedTypes = []
                    return
                }

                axios.post(this.route('api.vector.acessories.types.delete'), {data: this.selectedTypes})
                    .then((result) => {
                        this.getData()
                        this.selectedTypes = []
                        this.$toast.add({ severity: 'success', summary: 'Успішно збережено!', detail: 'Типи аксесуарів успішно видалено', life: 3000 });
                    }).catch((error) => {
                        this.selectedTypes = []
                        console.log(error);
                        window.scroll(0, 0);
                    })

            });
        },
        onPage(event) {
            this.filterParams.page = event.page+1
            this.filterParams.perPage = event.rows
            this.getData()
        },
        onSelectAllChange() {
            if (this.data.length >= this.filterParams.perPage) {
                if (!this.selectAll) {
                    this.selectAll = true;
                    this.selectedTypes = this.data
                } else {
                    this.selectAll = false;
                    this.selectedTypes = [];
                }
            }
        },
        onRowSelect() {
            if (this.data.length >= this.filterParams.perPage) {
                this.selectAll = this.selectedTypes.length === this.data.length
            }
        },
        onRowUnselect() {
            if (this.data.length >= this.filterParams.perPage) {
                this.selectAll = false;
            }
        }
    }
};
</script>

<style scoped>
.bottom_btns {
    display: flex;
    gap: 16px;
    padding-top: 50px;
}
.add_file_btn {
    color: #FFF;
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: 24px;
    border-radius: 4px;
    background: #356EEF;
    display: flex;
    width: 237px;
    height: 40px;
    padding: 8px 16px;
    justify-content: center;
    align-items: center;
    text-decoration: none!important;
}
.add_file_btn.disabled {
    cursor:not-allowed;
    filter: opacity(0.5);
}
.add_file_btn.main {
    background-color: #FFFFFF;
    font-size: 16px;
    font-weight: 400;
    line-height: 24px;
    text-align: center;
    color: #000000;
    box-shadow: 0px 1px 2px 0px #0000004D;
}
.confirm_buttons {
    display: flex;
    gap: 20px;
}
.confirm_button_cancel {
    display: flex;
    padding: 12px 30px;
    flex-direction: column;
    align-items: center;
    border-radius: 4px;
    background: #356EEF;
    color: #FFF;
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: 24px;
    width: 100%;
}
.confirm_button_confirm {
    display: flex;
    padding: 12px 30px;
    flex-direction: column;
    align-items: center;
    border-radius: 4px;
    background: #FFF;
    color: #000;
    font-size: 16px;
    font-style: normal;
    font-weight: 400;
    line-height: 24px;
    width: 100%;
    box-shadow: 0px 1px 4px 0px rgba(0, 0, 0, 0.30);
}
.price_input {
    height: 40px!important;
    width: 100%;
    align-items: center;
    display: flex;
}
.check-text input {
  display: none;
}
.check-text svg {
  cursor: pointer;
}
.modal_main_content_container {
    display: flex;
    flex-direction: column;
    gap: 20px;
}
</style>
